import { render, staticRenderFns } from "./TreatmentStep.vue?vue&type=template&id=1de86cf8&"
import script from "./TreatmentStep.vue?vue&type=script&lang=js&"
export * from "./TreatmentStep.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentStep.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports